import {
  faHouseWindow,
  faMessagesQuestion,
  faSquarePollHorizontal,
  faUserFriends,
} from "@fortawesome/pro-light-svg-icons";
import SignedInUserDto from "../../types/dtos/users/SignedInUserDto";
import SubNavItem from "../../types/nav/SubNavItem";
import AppRoutes from "../AppRoutes";
import taskTypeIconHelper from "../../helpers/taskTypeIconHelper";
import { userDetailsHelper } from "../../helpers";

const YourJourneySubNavItems = (
  loggedInUser: SignedInUserDto
): SubNavItem[] => {
  let output: SubNavItem[] = [];

  const myDashboardBadgeNumber =
    userDetailsHelper.getOwnUpdateCount(loggedInUser);

  // The main employee dashboard
  output.push({
    title: "Nav.LargeScreen.MyDashboard.Home",
    translateTitle: true,
    url: AppRoutes.yourJourney.root,
    badgeCount: myDashboardBadgeNumber > 0 ? myDashboardBadgeNumber : undefined,
    icon: faHouseWindow,
  });

  // Addition of 'Conversations'
  output.push({
    title: "Nav.LargeScreen.MyDashboard.Conversations",
    translateTitle: true,
    url: AppRoutes.yourJourney.conversations,
    badgeCount: undefined,
    icon: faMessagesQuestion,
  });

  if (loggedInUser.client.usesPulseChecks) {
    // Addition of 'Pulse Checks'
    output.push({
      title: "Nav.LargeScreen.MyDashboard.PulseChecks",
      translateTitle: true,
      url: AppRoutes.yourJourney.pulseChecks,
      badgeCount: undefined,
      icon: faSquarePollHorizontal,
    });
  }

  // Addition of 'Catch Ups'
  output.push({
    title: "Nav.LargeScreen.MyDashboard.CatchUps",
    translateTitle: true,
    url: AppRoutes.yourJourney.catchUps,
    badgeCount: undefined,
    icon: faUserFriends,
  });

  // Addition of AdvancedTaskTypes
  loggedInUser.client.taskTypes.forEach((clientTaskType) => {
    const taskTypeHighlights = loggedInUser.highlightedTasks.find(
      (x) => x.taskTypeId === clientTaskType.id
    );
    output.push({
      title: clientTaskType.shortTitleTranslationKeyIdentifier,
      translateTitle: true,
      url: AppRoutes.yourJourney.tasks.generatePathRoute(clientTaskType.id),
      badgeCount: taskTypeHighlights?.ownTaskIds
        ? taskTypeHighlights.ownTaskIds.length
        : undefined,
      icon: taskTypeIconHelper.getTaskTypeIcon(
        clientTaskType.iconType,
        "LIGHT"
      ),
    });
  });
  return output;
};

export default YourJourneySubNavItems;
